<template>
  <div>
    <slot />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      type: 'auth/type'
    })
  },
  watch: {
    headHeight (val) {
      this.$refs.header.style.height = `${val}px`
      this.$refs.content.style.height = `${this.windowHeight - val}px`
    },
    windowHeight (val) {
      this.$refs.content.style.height = `${val - this.headHeight}px`
    }
  }
}
</script>
